import React, { useState, useEffect } from "react";
import { Button, Input } from "../components/Form";
import { BiReset } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import authService from "../api/authService";

function ResetPassword() {
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const emailParam = params.get("email");
        if (emailParam) {
            setEmail(emailParam);
        }
    }, [location]);

    const submitHandler = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (!email || !otp || !password || !confirmPassword) {
                toast.error("Please provide all fields");
                setLoading(false);
                return;
            }
            if (password !== confirmPassword) {
                toast.error("Passwords do not match");
                setLoading(false);
                return;
            }
            if (password.length < 8) {
                toast.error("Password must be at least 8 characters");
                setLoading(false);
                return;
            }
            await authService.resetPassword(email, otp, password);
            toast.success("Password reset successfully. You can now login.");
            navigate("/");
        } catch (error) {
            const msg = error.response?.data?.message || "Failed to reset password";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='flex-colo h-screen w-full bg-dry'>
            <form onSubmit={submitHandler} className='flex-colo mx-auto w-[90%] md:w-2/5 rounded-2xl bg-white p-8'>
                <img
                    src='/images/logo.png'
                    alt='logo'
                    className='h-16 w-48 object-contain'
                />
                <div className='mb-6 flex w-full flex-col gap-4 text-center mt-4'>
                    <h2 className='text-2xl font-bold text-gray-800'>Reset Password</h2>
                    <p className='text-sm text-gray-500'>Enter the OTP sent to your email and your new password.</p>
                    <div className='text-left flex flex-col gap-4'>
                        <Input
                            label='Email'
                            type='email'
                            color={true}
                            placeholder={"Enter your email address"}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <Input
                            label='OTP'
                            type='text'
                            color={true}
                            placeholder={"Enter OTP"}
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />
                        <Input
                            label='New Password'
                            type='password'
                            color={true}
                            placeholder={"Minimum 8 characters"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Input
                            label='Confirm New Password'
                            type='password'
                            color={true}
                            placeholder={"Re-enter new password"}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                </div>
                <Button
                    label={loading ? "Loading..." : "Reset Password"}
                    Icon={BiReset}
                    onClick={submitHandler}
                    disabled={loading}
                />
            </form>
        </div>
    );
}

export default ResetPassword;

